import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function PagoSuccess() {
  const location = useLocation();
  return <Navigate to={`/thanks-mp${location.search}`} replace />;
}
